import React from "react";
import { Link, withRouter } from "react-router-dom";
import { inject } from "mobx-react";
import { Button, Radio } from "antd";

import { $const } from "../../../../helper";
import Language from "../../../language/language";
import AdaptiveTooltip from "../../../AdaptiveTooltip";
import Modal from "../../../modal/modal";
import CollegesInfo from "../collegesInfo";

import "../../stylesheets/teamBasicInfo.scss";
import classNames from "classnames";

@inject("teamStore", "languageStore", "commonStore")
@withRouter
class BasicInfo extends React.Component {
  state = {
    chinaArea: null,
    deleteTeamConfirm: false,
    showDeleteTeam: false
  };

  componentDidMount() {
    this.getPca();
  }

  formatAreaCode = chinaArea => {
    if (!(Array.isArray(chinaArea) && chinaArea.length > 0)) return [];
    const list = [];
    for (let item of chinaArea) {
      const { value, label, children } = item;
      value && label && list.push({ value, label });
      if (Array.isArray(children) && children.length) {
        list.push(...this.formatAreaCode(children));
      }
    }
    return list;
  };

  getPca = () => {
    this.props.commonStore.getPca().then(data => {
      this.setState({
        chinaArea: this.formatAreaCode(data)
      });
    });
  };

  getCityByCode = (consigneeProvinceCode, consigneeCityCode, consigneeDistrictCode) => {
    const { chinaArea } = this.state;
    if (!(Array.isArray(chinaArea) && chinaArea.length > 0)) return "";
    let province,
      city,
      district,
      provinceTag = !consigneeProvinceCode,
      cityTag = !consigneeCityCode,
      districtTag = !consigneeDistrictCode;
    for (let item of chinaArea) {
      if (provinceTag && cityTag && districtTag) break;
      const { value, label } = item;
      value === consigneeProvinceCode && (province = label) && (provinceTag = true);
      value === consigneeCityCode && (city = label) && (cityTag = true);
      value === consigneeDistrictCode && (district = label) && (districtTag = true);
    }
    (city === "市辖区" || city === "县") && (city = "");
    return `${province || ""}${city || ""}${district || ""}`;
  };

  getAddress = () => {
    const lang = this.props.languageStore.lang;
    const options = $const.COUNTRIES[lang];
    const teamInfo = this.props.teamStore.teamInfo;

    const { chinaArea } = this.state;
    if (teamInfo && chinaArea) {
      const {
        consigneeCountryCode,
        consigneeCityCode,
        consigneeDistrictCode,
        consigneeAddress,
        consigneeProvinceCode
      } = teamInfo;
      const country = options.find(item => item.value === consigneeCountryCode);
      const city = this.getCityByCode(
        consigneeProvinceCode,
        consigneeCityCode,
        consigneeDistrictCode
      );
      return `${country ? country.label : ""}${city}${consigneeAddress || ""}`;
    }
    return "-";
  };

  showDeleteTeamModal = () => {
    this.props.commonStore.gTag("event", "disBandTeam", {
      pageName: "gameApplyInfo",
      buttonName: "解散战队"
    });
    this.setState({
      showDeleteTeam: true
    });
  };

  closeDeleteTeamModal = () => {
    this.setState({
      showDeleteTeam: false,
      deleteTeamConfirm: false
    });
  };

  deleteTeam = () => {
    this.props.teamStore
      .deleteTeam({
        variables: {
          input: {
            id: this.props.info.id
          }
        }
      })
      .then(() => {
        this.setState({
          showDeleteTeam: false
        });
        this.props.history.push("/control-center");
      });
  };

  onEditTeamInfo = () => {
    this.props.commonStore.gTag("event", "editTeamInfo", {
      pageName: "gameApplyInfo",
      buttonName: "修改资料"
    });
  };

  changeDeleteTeamConfirm = () => {
    this.setState({
      deleteTeamConfirm: true
    });
  };

  judgeEditState = (teamInfo, currentTeamIsSpecialGame, showCollectionStage, canManageTeam) => {
    if (currentTeamIsSpecialGame && showCollectionStage) {
      // UC和UL且当前处于收集名单环节，可以编辑信息
      return true;
    } else if (currentTeamIsSpecialGame && !showCollectionStage) {
      // UC和UL且当前不处于收集名单环节
      return false;
    } else {
      // 非UC和UL
      return canManageTeam && teamInfo.status !== $const.TEAM_STATUS.LOCKED;
    }
  };

  render() {
    const teamInfo = this.props.teamStore.teamInfo;
    // 当前用户是否有战队管理权限
    const canManageTeam = teamInfo.isCaptain || teamInfo.isSubCaptain;
    const schoolsInfo = this.props.schoolsInfo;
    const currentTeamIsSpecialGame = this.props.teamStore.currentTeamIsSpecialGame;
    const showCollectionStage = this.props.teamStore.showCollectionStage;
    const canEdit = this.judgeEditState(
      teamInfo,
      currentTeamIsSpecialGame,
      showCollectionStage,
      canManageTeam
    );

    return (
      <div className={classNames("teamBasicInfo", this.props.className)}>
        <div className="teamBasicInfo__subInfo">
          <Language className="teamBasicInfo__subInfo--title" resource="TEAM_INFO"></Language>
          {canEdit ? (
            <div className="teamBasicInfo__subInfo--edit" onClick={this.onEditTeamInfo}>
              <Link to={`/team-info-edit/${teamInfo.id}`}>
                <Language resource="EDIT_TEAM_INFO" />
              </Link>
            </div>
          ) : null}
          {!currentTeamIsSpecialGame &&
          canManageTeam &&
          teamInfo.status !== $const.TEAM_STATUS.LOCKED &&
          teamInfo.status !== $const.TEAM_STATUS.EDIT ? (
            // LOCKED EDIT 均不允许删除队伍
            <div
              onClick={this.showDeleteTeamModal}
              className="teamBasicInfo__subInfo--delete"
              key="delete-team"
            >
              <Language resource="DELETE_TEAM" />
            </div>
          ) : null}
        </div>
        {teamInfo.nameEn ? (
          <div className="teamBasicInfo__otherInfo">
            <Language resource="ENGLISH_NAME" />
            {`: ${teamInfo.nameEn}`}
          </div>
        ) : null}
        {teamInfo.campusOrganization ? (
          <div className="teamBasicInfo__otherInfo">
            <Language resource="CAMPUS_ORGANIZATION" />
            {`: ${teamInfo.campusOrganization}`}
          </div>
        ) : null}
        {canManageTeam && teamInfo.introductionLink ? (
          <AdaptiveTooltip className="teamBasicInfo__otherInfo" title={teamInfo.introductionLink}>
            <Language resource="INTRODUCTIONLINK" />
            {`: ${teamInfo.introductionLink}`}
          </AdaptiveTooltip>
        ) : null}
        {canManageTeam && teamInfo.teamSlogan ? (
          <AdaptiveTooltip className="teamBasicInfo__otherInfo" title={teamInfo.teamSlogan}>
            <Language resource="TEAM_SLOGAN" />
            {`: ${teamInfo.teamSlogan}`}
          </AdaptiveTooltip>
        ) : null}
        {canManageTeam && teamInfo.consigneeName ? (
          <div className="teamBasicInfo__otherInfo">
            <Language resource="ADDRESSEE" />
            {`: ${teamInfo.consigneeName}`}
          </div>
        ) : null}
        {canManageTeam && teamInfo.consigneePhone ? (
          <div className="teamBasicInfo__otherInfo">
            <Language resource="ADDRESSEE_PHONE" />
            {`: ${teamInfo.consigneePhone}`}
          </div>
        ) : null}
        {canManageTeam && teamInfo.consigneeCountryCode && teamInfo.consigneeAddress ? (
          <div className="teamBasicInfo__otherInfo">
            <Language resource="ADDRESSEE_ADRESS" />
            {`: ${this.getAddress()}`}
          </div>
        ) : null}
        {schoolsInfo ? <CollegesInfo info={schoolsInfo} edit={canEdit} /> : null}
        <Modal
          className="teamBasicInfo__deleteTeam"
          title={<Language resource="DELETE_TEAM" />}
          state={this.state.showDeleteTeam}
          close={this.closeDeleteTeamModal}
        >
          <div className="teamBasicInfo__deleteTeam--subTitle">
            <Language resource="DELETE_TEAM_TIP"></Language>
          </div>
          <div className="teamBasicInfo__deleteTeam--change">
            <div className="teamBasicInfo__deleteTeam--confirm">
              <Radio checked={this.state.deleteTeamConfirm} onChange={this.changeDeleteTeamConfirm}>
                <Language resource="DELETE_TEAM_CONFIRM"></Language>
              </Radio>
            </div>
            <Button
              disabled={!this.state.deleteTeamConfirm}
              type="primary"
              onClick={this.deleteTeam}
            >
              <Language resource="CONFIRM"></Language>
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default BasicInfo;



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/teamInfoTabs/basicInfo.js